module.exports = __webpack_public_path__ + "img/hr-dead-grey-trunk-01.e8fe86c1.png";